import React from "react";

const ReviewComplete = () => {
  return (
    <>
      <div
        className={"bg-gray-indicators h-[6.55px] mr-0.5 w-[17px]"}
        style={{ borderRadius: "2.34px" }}
      ></div>{" "}
      <div
        className={"bg-gray-indicators h-[6.55px] mr-0.5 w-[17px]"}
        style={{ borderRadius: "2.34px" }}
      ></div>{" "}
      <div
        className={"bg-gray-indicators h-[6.55px] mr-0.5 w-[17px]"}
        style={{ borderRadius: "2.34px" }}
      ></div>{" "}
      <div
        className={"bg-primary-yellow h-[6.55px] mr-0.5 w-[76.04px]"}
        style={{ borderRadius: "2.34px" }}
      ></div>{" "}
    </>
  );
};

export default ReviewComplete;
